





















































import tools from "@/tools.coffee"
import moment from "moment"
import settings from "@/settings.coffee"

export default {
    "name": "Comment"
    "props": {
        "content": Object
        "disabled": {
            "type": Boolean,
            "default": false
        }
        "isAnswerWriting": false
    }
    "filters":
        "remove_newline": (txt)->
            if txt
                return txt.replace("\\n"," ")
            return txt
        "fix_newline": (txt)->
            if txt
                return txt.replace("\\n","\n")
            return txt
    "data": ()->
        return {
            "create": true
            "context": null
            "this_text": ""
            "comment_editable": false
        }
    "computed":
        "human_posted_on": ()->
            return moment(@context.posted_on).fromNow()
        "avatar_url": ()->
            if this.context.who == @$store.state.profile.data.fullname
                if this.content.avatar?
                    return settings.backendUrl + @$store.state.profile.data.avatar
                else
                    return null
            else
                if this.content.avatar?
                    return settings.backendUrl + this.content.avatar
                else
                    return null
    "methods":
        "text_html": (text)->
            return text.replace(/(?:\r\n|\r|\n)/g, "<br>")
        "get_uid": ()->
            return String(@context.posted_on)+"_"+@context.who
        "edit_comment": ()->
            @comment_editable = true
        "save_comment": ()->
            @comment_editable = false
            data = tools.deep_copy(@context)
            @$emit("comment:update", tools.deep_copy(@context))
        "send": ()->
            # create a new comment
            @context.posted_on = moment().toDate()
            @context.text = @this_text.replace(/(?:\r\n|\r|\n)/g, "<br>")
            @$emit("comment:send", tools.deep_copy(@context))
            @this_text = ""
            @$store.commit("delete_edited_fields", {
                key: "comment"
            })


    "created": ()->
        @this_text = @content.text
        @context = @content
        
        if @content.text == null
            @create = true
        else
            @context.text = @context.text.replace(/<br>/g, "\n")
            @create = false
    "watch":
        "this_text": (newV, oldV)->
            if this.$refs.comment_input?
                @$store.commit("update_edited_fields", {
                    key: "comment"
                    value: newV
                    verbose_name: "Commentaire"
                    el: this.$refs.comment_input
                })
        
}
